const campains = [{
    "campaign_name": "Ride On Pizzeria",
    "feature_tags": ["rideonpizzeria", "Royalnorthshorehospital"],
    "city_location": ["North Sydney", "Neutral Bay", "St Leonards", "Artarmon"],
    "city_place_ids": ["ChIJ2b2yeLWvEmsRQMQyFmh9AQU", "ChIJO39xG5GuEmsRMMMyFmh9AQU", "ChIJM_IDxN2uEmsREMwyFmh9AQU", "ChIJDbLtntmuEmsR0KsyFmh9AQU"],
    "start_date": "01/11/2020",
    "end_date": "30/11/2020"
}];

export default campains;